import Button from "./Button"
import { GamepadIcon as GameController } from "lucide-react"

export default function CTASection() {
  return (
    <section className="container mx-auto px-4 py-20">
      <div className="bg-gradient-to-r from-red-500/20 to-zinc-800/50 rounded-2xl p-8 md:p-12 border border-red-500/30 relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-500/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <GameController className="h-16 w-16 text-red-500 mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Find Your Dream Squad?</h2>
          <p className="text-xl text-zinc-300 mb-8">
            Join thousands of Valorant players who've already leveled up their gaming experience with FragNades.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button size="lg" className="bg-red-500 hover:bg-red-600 text-white">
              Create Free Account
            </Button>
            <Button size="lg" variant="outline" className="border-red-500 text-red-500 hover:bg-red-500/10">
              Learn More
            </Button>
          </div>
          <p className="mt-6 text-zinc-500 text-sm">No credit card required. Start matching with players in minutes.</p>
        </div>
      </div>
    </section>
  )
}

